// extracted by mini-css-extract-plugin
export default {"input":"EditCategoryForm_input__Nq5PL","error":"EditCategoryForm_error__COqT+","button":"EditCategoryForm_button__YLyo2"};